<template>
  <div :title="fullAuthors">
    <span>{{ showingAuthors }}</span>
    <div v-if="shouldTruncate" class="mt-1 expansion-button">
      <a @click="toggleExpansion">
        <span>{{ expandLabel }}</span>
        <span>
          <v-icon color="primary">{{ expandIcon }}</v-icon>
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthorsReferenceField',
  props: {
    authors: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    showAll: false,
  }),
  computed: {
    fullAuthors() {
      return this.authors != null && this.authors.length
        ? this.authors.join('; ')
        : '-';
    },
    shouldTruncate() {
      return this.fullAuthors.length > 250;
    },
    truncatedAuthors() {
      return this.shouldTruncate
        ? this.fullAuthors.slice(0, 250) + '...'
        : this.fullAuthors;
    },
    showingAuthors() {
      return this.showAll ? this.fullAuthors : this.truncatedAuthors;
    },
    expandLabel() {
      return this.showAll ? 'Show less' : 'Show more';
    },
    expandIcon() {
      return this.showAll ? 'arrow_drop_up' : 'arrow_drop_down';
    },
  },
  methods: {
    toggleExpansion() {
      this.showAll = !this.showAll;
    },
  },
};
</script>

<style scoped>
.expansion-button {
  cursor: pointer;
}
</style>
